import React from 'react';
import { motion } from 'framer-motion';
import { Megaphone, Target, Calendar, UserPlus, CheckCircle2 } from 'lucide-react';
export function Services() {
  const services = [{
    icon: <Megaphone className="w-8 h-8" data-id="element-180" />,
    title: 'Digital Marketing & Brand Development',
    items: ['Content strategy', 'Social media management', 'Email campaigns', 'Brand development'],
    desc: 'Elevate your market presence with data-driven creative strategies.'
  }, {
    icon: <Target className="w-8 h-8" data-id="element-181" />,
    title: 'Cold Outreach & Lead Qualification',
    items: ['Phone outreach', 'Email prospecting', 'Prospect research', 'Lead qualification'],
    desc: 'Strategic prospecting that fills your pipeline with high-intent leads.'
  }, {
    icon: <Calendar className="w-8 h-8" data-id="element-182" />,
    title: 'Lead Generation & Appointment Setting',
    items: ['Inbound management', 'Appointment setting', 'Funnel optimization', 'Industry lead systems'],
    desc: 'Turn interest into action with seamless appointment setting workflows.'
  }, {
    icon: <UserPlus className="w-8 h-8" data-id="element-183" />,
    title: 'HRaaS & Staffing Solutions',
    items: ['On-demand staffing', 'Customer service', 'Admin support', 'Recruitment support'],
    desc: 'Flexible staffing models that adapt to your business velocity.'
  }];
  return <section id="services" className="py-24" data-id="element-184">
      <div className="container mx-auto px-6" data-id="element-185">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-186">
          <h2 className="text-brand-accent font-bold tracking-widest uppercase text-sm mb-4" data-id="element-187">
            Our Expertise
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-188">
            Comprehensive Business Support
          </h3>
          <p className="text-lg text-slate-400" data-id="element-189">
            Tailored solutions designed to remove operational bottlenecks and
            accelerate your growth trajectory.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-190">
          {services.map((s, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="group p-8 rounded-3xl bg-white/5 border border-white/10 hover:border-brand-accent/50 transition-all relative overflow-hidden" data-id="element-191">
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-192">
                {s.icon}
              </div>
              <div className="text-brand-accent mb-6 group-hover:scale-110 transition-transform origin-left" data-id="element-193">
                {s.icon}
              </div>
              <h4 className="text-xl font-bold text-white mb-4 leading-tight" data-id="element-194">
                {s.title}
              </h4>
              <p className="text-sm text-slate-400 mb-6 leading-relaxed" data-id="element-195">
                {s.desc}
              </p>

              <ul className="space-y-3" data-id="element-196">
                {s.items.map((item, idx) => <li key={idx} className="flex items-center gap-2 text-sm text-slate-300" data-id="element-197">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent/60" data-id="element-198" />
                    {item}
                  </li>)}
              </ul>

              <div className="mt-8 pt-6 border-t border-white/10" data-id="element-199">
                <button className="text-brand-accent text-sm font-bold flex items-center gap-2 group-hover:gap-3 transition-all" data-id="element-200">
                  Learn More <span className="text-lg" data-id="element-201">→</span>
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}